import { sessaoFetchLoading } from '@/service/fetch'
import { serialize } from '@/service/util'

export async function get (id) {
  return sessaoFetchLoading(`consig`, `/comunicado/${id}`)
}
export async function getComunicados (dados) {
  return sessaoFetchLoading(`consig`, `/comunicado/ListarTodosPaginadoQueryEnvelopado?` + serialize(dados), 'GET')
}
export async function add (dados) {
  return sessaoFetchLoading(`consig`, `/comunicado/AddComunicadoPromotoras`, 'POST', dados)
}
export async function edit (dados) {
  return sessaoFetchLoading(`consig`, `/comunicado`, 'PUT', dados)
}
export async function del (dados) {
  return sessaoFetchLoading(`consig`, `/comunicado/${dados}`, 'DELETE')
}
export async function getByUsuario (dados) {
  return sessaoFetchLoading(`consig`, `/comunicado/listar`)
}
export async function ler (id) {
  return sessaoFetchLoading(`consig`, `/comunicado_usuario/${id}`, 'POST')
}
export async function naoLido () {
  return sessaoFetchLoading(`consig`, `/comunicado/PrimeiroNaoLido`)
}



// WEBPACK FOOTER //
// ./src/api/comunicado.js